module.exports = __webpack_public_path__ + "static/img/row4.17c9bbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/row4.png
// module id = GiIn
// module chunks = 12